import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { switchMap, map, catchError, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { MwDeliveriesApiService } from 'app/services/deliveries-api.service';
import * as deliveriesActions from '../actions/deliveries.actions';
import * as notifyActions from 'app/store/general/actions/notify.actions';
import { Store } from '@ngrx/store';
import { MwLoadOptions } from 'app/models/load-options.model';
@Injectable()
export class DeliveriesEffects {
  constructor(
    private actions$: Actions,
    private store$: Store<any>,
    private deliveriesApiService: MwDeliveriesApiService
  ) {}

  loadDeliveries$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(deliveriesActions.loadDeliveries),
      withLatestFrom(this.store$),
      switchMap(([{ loadOptions }, state]) => {
        const options = loadOptions;
        return this.deliveriesApiService.load(options).pipe(
          map((response) => {
            return deliveriesActions.loadDeliveriesSuccess({
              response,
            });
          }),
          catchError((error) =>
            of(deliveriesActions.loadDeliveriesFailed({ error }))
          )
        );
      })
    );
  });

  loadDelivery$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(deliveriesActions.loadDelivery),
      withLatestFrom(this.store$),
      switchMap(([{ deliveryId }, state]) => {
        const loadOptions = new MwLoadOptions({
          sort: [],
          hasCount: false,
          filter: ['deliveryId', '=', deliveryId],
          numericParameters: { deliveryId: true },
        });

        return this.deliveriesApiService.load(loadOptions).pipe(
          map((response) => {
            return deliveriesActions.loadDeliverySuccess({
              delivery: response?.[0],
            });
          }),
          catchError((error) =>
            of(deliveriesActions.loadDeliveryFailed({ error }))
          )
        );
      })
    );
  });

  createDelivery$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deliveriesActions.createDelivery),
      switchMap(({ delivery }) => {
        return this.deliveriesApiService.create(delivery).pipe(
          switchMap((response) => [
            deliveriesActions.createDeliverySuccess({ delivery: response }),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.add_delivery_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(deliveriesActions.createDeliveryFailed({ error }))
          )
        );
      })
    )
  );

  updateDelivery$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deliveriesActions.updateDelivery),
      switchMap(({ delivery }) => {
        return this.deliveriesApiService.update(delivery).pipe(
          switchMap(() => [
            deliveriesActions.updateDeliverySuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.update_delivery_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(deliveriesActions.updateDeliveryFailed({ error }))
          )
        );
      })
    )
  );

  deleteDelivery$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deliveriesActions.deleteDelivery),
      switchMap(({ delivery }) => {
        return this.deliveriesApiService.delete(delivery).pipe(
          switchMap(() => [
            deliveriesActions.deleteDeliverySuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.delete_delivery_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(deliveriesActions.deleteDeliveryFailed({ error }))
          )
        );
      })
    )
  );
}
